module.exports = __webpack_public_path__ + "static/media/moons_plan_de_tratamiento.a10c80ab.jpg";